define([
    'text!product-detail/furniture/maintain-info.html',
    'common/utils',
    'product-detail/store',

    'css!product-detail/furniture/maintain-info.css'
], function(
    tpl,
    Utils,
    Store
){
    return {
        template: tpl,
        data: function(){
            return {
                maintainText: ''
            };
        },
        methods: {
            init: function(){
                var spuExtraBase = Store.getSpuExtraBase();
                this.maintainText = spuExtraBase&&spuExtraBase.maintainText || '';
            },
            ln2br: Utils.ln2br
        },
        created: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/furniture/maintain-info.js
// module id = 217
// module chunks = 0